import { DateTimeWidget } from "Components/optionForm";
import React, { useCallback, useMemo, memo } from "react";
import ranges from "Common/dateTimeUtils/ranges";
import locale from "../taskStatisticsFilter.locale";
function DateRangeFilter({ from, to, onApplyFilter }) {
    const dateTimeLimits = useMemo(() => ({
        max: ranges.TODAY().endDateTime
    }), [from, to]);
    const handleDateFromChange = useCallback((value) => {
        const params = { from: value };
        onApplyFilter(params);
    }, [from, onApplyFilter]);
    const handleDateToChange = useCallback((value) => {
        const params = { to: value };
        onApplyFilter(params);
    }, [to, onApplyFilter]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DateTimeWidget, { height: 44, width: 170, useUtc: true, withApplyButton: true, showDropDownButton: false, showClearButton: true, openOnFieldClick: true, value: from, onChange: handleDateFromChange, label: locale.DATE_FROM, labelMode: "floating", dateTimeLimits: dateTimeLimits }),
        React.createElement(DateTimeWidget, { height: 44, width: 170, useUtc: true, withApplyButton: true, showDropDownButton: false, showClearButton: true, openOnFieldClick: true, value: to, onChange: handleDateToChange, label: locale.DATE_TO, labelMode: "floating", dateTimeLimits: dateTimeLimits })));
}
export default memo(DateRangeFilter);
